import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  Ch_approveConsultationReportInput,
  useApproveConsultationReportMutation as useApproveConsultationReportMutationType,
} from "@/modules/patients/detail/consultation-report/services/__generated__/useApproveConsultationReportMutation.graphql"

const approveConsultationReportMutation = graphql`
  mutation useApproveConsultationReportMutation($input: Ch_approveConsultationReportInput!) {
    ch_approveConsultationReport(input: $input) {
      ch_ConsultationReport {
        id
        progressNoteId
        fileId
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
        signedAt
        signedBy
        updatedAt
        updatedBy
      }
      errors {
        ... on DocumentDoesNotExist {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useApproveConsultationReportMutationType>, "variables"> & {
  id: Ch_approveConsultationReportInput["id"]
}

export const useApproveConsultationReportMutation = () => {
  const [commit, isLoading] = useMutationWithErrorDialog<useApproveConsultationReportMutationType>(
    approveConsultationReportMutation,
  )

  const commitHandler = useCallback(
    (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isLoading] as const
}
